// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nspan {\n    background: linear-gradient(to right, #999999, #C1C1C1, #F3F3F3);\n    -webkit-background-clip: text;\n    color: transparent;\n    position: relative;\n    top: -7vw;\n    display: block;\n}\n", ""]);
// Exports
module.exports = exports;
